<div class="main-panel">
  <div class="content">
    <div class="page-inner">
      <div class="row">
        <div style="display:flex;
        justify-content: center;
        align-items: center">
          <img src="../../../assets/img/page-not-found.png"/>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>